module.exports = __webpack_public_path__ + "img/02-top-img.9f42e012.png";